import { c as _c } from "react/compiler-runtime";
import { type DetailedHTMLProps, type DialogHTMLAttributes, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import { cn } from '@/lib/cn';
import type { CmsContainerWidth } from '@/services/cms-sdk/schemas/models/CmsContainerWidth';
import { cmsWidthToClassName } from '@/styles/global';
export interface ModalProps extends DetailedHTMLProps<DialogHTMLAttributes<HTMLDialogElement>, HTMLDialogElement> {
  closeOnOutsideClick?: boolean;
  width?: CmsContainerWidth;
  showClose?: boolean;
}
export function Modal(t0) {
  const $ = _c(37);
  let children;
  let className;
  let inOpen;
  let onClose;
  let props;
  let ref;
  let showClose;
  let t1;
  let width;
  if ($[0] !== t0) {
    ({
      children,
      open: inOpen,
      onClose,
      showClose,
      closeOnOutsideClick: t1,
      className,
      width,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = inOpen;
    $[4] = onClose;
    $[5] = props;
    $[6] = ref;
    $[7] = showClose;
    $[8] = t1;
    $[9] = width;
  } else {
    children = $[1];
    className = $[2];
    inOpen = $[3];
    onClose = $[4];
    props = $[5];
    ref = $[6];
    showClose = $[7];
    t1 = $[8];
    width = $[9];
  }
  const closeOnOutsideClick = t1 === undefined ? true : t1;
  const [open, setOpen] = useState(inOpen);
  const [prevInOpen, setPrevInOpen] = useState(inOpen);
  if (inOpen !== prevInOpen) {
    setOpen(inOpen);
    setPrevInOpen(inOpen);
  }
  const internalRef = useRef(null);
  let t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => internalRef.current as HTMLDialogElement;
    t3 = [];
    $[10] = t2;
    $[11] = t3;
  } else {
    t2 = $[10];
    t3 = $[11];
  }
  useImperativeHandle(ref, t2, t3);
  let t4;
  if ($[12] !== open) {
    t4 = () => {
      const dialog = internalRef.current;
      if (!dialog) {
        return;
      }
      if (open && !dialog.open) {
        dialog.showModal();
      }
      if (!open && dialog.open) {
        dialog.close();
      }
    };
    $[12] = open;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== onClose || $[15] !== open) {
    t5 = [open, onClose];
    $[14] = onClose;
    $[15] = open;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  useEffect(t4, t5);
  let t6;
  if ($[17] !== className) {
    t6 = cn("modal", className);
    $[17] = className;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== onClose) {
    t7 = e => {
      setOpen(false);
      onClose?.(e);
    };
    $[19] = onClose;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== width) {
    t8 = cn("modal-box", cmsWidthToClassName(width), {
      "max-w-full": !width,
      "max-w-full w-full": width === "Full"
    });
    $[21] = width;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== showClose) {
    t9 = showClose ? <button className="btn btn-circle flex items-center justify-center border border-white size-10 bg-black/[32%] absolute right-4 top-4 z-10 text-white input-focus-transition hover:bg-black/[40%]" onClick={() => setOpen(false)} aria-label="Close" type="button" data-testid="modal-close-button"><PhosphorIcon name="x" className="text-2xl" /></button> : null;
    $[23] = showClose;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== children || $[26] !== t8 || $[27] !== t9) {
    t10 = <div className={t8}>{t9}{children}</div>;
    $[25] = children;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== closeOnOutsideClick) {
    t11 = closeOnOutsideClick ? <form method="dialog" className="modal-backdrop"><button>close</button></form> : null;
    $[29] = closeOnOutsideClick;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== props || $[32] !== t10 || $[33] !== t11 || $[34] !== t6 || $[35] !== t7) {
    t12 = <dialog ref={internalRef} className={t6} onClose={t7} {...props}>{t10}{t11}</dialog>;
    $[31] = props;
    $[32] = t10;
    $[33] = t11;
    $[34] = t6;
    $[35] = t7;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
}